<!-- 积分管理  Points management-->
<template>
  <div class="management">
    <div class="form_header">
      <el-form ref="form" :model="userform" label-width="100px">
        <div class="form_list">
          <el-form-item label="产品线：">
            <el-select v-model="userform.Product" placeholder="请选择产品线">
              <el-option v-for="item in prodlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备名称：">
            <el-input v-model="userform.name"></el-input>
          </el-form-item>
          <div>
            <el-button type="primary" @click="onSubmit">搜索</el-button>
            <el-button @click="NOonsub">取消</el-button>
          </div>
        </div>
      </el-form>
      <div class="form_ri">
        <el-button type="primary" icon="el-icon-tickets" @click="mode">下载模板</el-button>
        <el-upload class="upload-demo" action accept=".xlsx, .xls, .csv" :show-file-list="false" :http-request="handlePreview" :limit="1">
          <el-button type="primary" icon="el-icon-download">导入</el-button>
        </el-upload>
        <el-button type="primary" icon="el-icon-upload2" @click="exportto">导出</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="addPoints">新增</el-button>
      </div>
    </div>
    <div class="user_list">
      <el-table :data="equipmentList" style="width: 100%" :row-class-name="rowClassName" @selection-change="handleSelectionChange" :header-cell-style="rowStyle" :cell-style="rowStyle">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="nickname" label="产品线" width="180">
          <template slot-scope="scope">
            <span>{{scope.row.products.name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="model" label="产品型号"></el-table-column>
        <!-- <el-table-column prop="serial_number" label="序列号"></el-table-column> -->
        <!-- <el-table-column prop="name" label="设备名称"></el-table-column> -->
        <el-table-column prop="img" label="设备图片" width="180">
          <template slot-scope="scope">
            <!-- <img style="width:30px;height:30px" :src="domainUrl+scope.row.img" alt /> -->
            <el-image v-if="scope.row.img" style="width: 40px; height: 40px" :src="domainUrl+scope.row.img" :preview-src-list="scope.row.srcList"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="integral" label="价值积分"></el-table-column>
        <el-table-column prop="is_top" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.is_top==0">未推荐</span>
            <span v-if="scope.row.is_top==1">已推荐</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="220">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="scope.row.index>0" @click="sort(scope.row,1)">上移</el-button>
            <el-button type="text" size="small" v-if="scope.row.index+1!==equipmentList.length" @click="sort(scope.row,2)">下移</el-button>
            <el-button v-if="scope.row.is_top==0" @click="handleClick(scope.row)" type="text" size="small">推荐</el-button>
            <el-button v-if="scope.row.is_top==1" @click="handleClick(scope.row)" type="text" size="small">取消推荐</el-button>

            <el-button type="text" size="small" @click="editbox(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="deletid(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fy_box">
      <el-pagination @current-change="handleCurrentChange" background prev-text="上一页" next-text="下一页" :current-page="currentindex" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totals"></el-pagination>
    </div>
    <!-- 编辑和新增弹窗 -->
    <el-dialog :title="titleName" :visible.sync="pop_up" @close="noform">
      <el-form :model="addform" :rules="rules" label-width="100px">
        <el-form-item label="产品线" prop="p_id">
          <el-select v-model="addform.p_id" filterable placeholder="请选择产品线">
            <el-option v-for="item in prodlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="设备名称" prop="name">
          <el-input v-model="addform.name"></el-input>
        </el-form-item>-->
        <el-form-item label="设备型号" prop="model">
          <el-input v-model="addform.model"></el-input>
        </el-form-item>
        <!-- <el-form-item label="序列号" prop="serial_number">
          <el-input v-model="addform.serial_number"></el-input>
        </el-form-item>-->
        <el-form-item label="价值积分" prop="integral">
          <el-input v-model="addform.integral" oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="设备图片" prop="integral">
          <el-upload action :http-request="handaddimg" accept=".png, .jpg, .jpeg" :limit="1" :file-list="addform.fileList" :class="{ hideUpload: addform.fileList.length > 0 }" list-type="picture-card" :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="addform.is_top == 1" label="推荐排序" >
          <el-input v-model="addform.recommend_sort" oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noform">取 消</el-button>
        <el-button type="primary" @click="SubmitAdd">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 推荐排序？ -->
    <el-dialog title="推荐位排序" :visible.sync="recommend_up" @close="noform">
      <el-form :model="recommendform" label-width="80px">
        <el-form-item label="排序">
          <el-input v-model="recommendform.recommend" oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noform">取 消</el-button>
        <el-button type="primary" @click="handleClickTwo">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  uploadimg,
  hostimg,
  integraltemplate,
  excelimport,
  excelexport
} from "../../api/comm.js";
import {
  integrallists,
  integraledit,
  integraleditTop,
  integraladd,
  integraldelete,
  integraleditSort,
  getProducts
} from "../../api/integral.js";
import { productslists } from "../../api/system.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      userform: {
        Product: "",
        name: ""
      },
      addform: {
        p_id: "",
        name: "",
        model: "",
        is_top: "",
        recommend_sort: "",
        serial_number: "",
        integral: "",
        fileList: []
      },
      recommendform: {
        recommend: ""
      },
      equipmentList: [
        {
          name: "王小虎",
          nickname: "大猫",
          province: "上海",
          Product: "1122@qq.com",
          integral: 1000,
          products: {
            name: ""
          }
        }
      ],
      currentindex: 1,
      pageSize: 10,
      totals: 100,
      titleName: "新增",
      pop_up: false,
      rules: {
        p_id: [{ required: true, message: "请选择产品线", trigger: "blur" }],
        name: [{ required: true, message: "设备名称", trigger: "blur" }],
        model: [{ required: true, message: "请输入设备型号", trigger: "blur" }],
        serial_number: [
          { required: true, message: "请输入设备序列号", trigger: "blur" }
        ],
        integral: [
          { required: true, message: "请输入设备积分", trigger: "blur" }
        ]
      },
      prodlist: [
        {
          name: "name",
          id: "id"
        }
      ],
      domainUrl: "",
      Checklist: [],
      recommend_up: false,
      recommenddata: {}
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    rowStyle() {
      return { textAlign: "center" };
    },
    //实时域名
    domainName() {
      hostimg().then(res => {
        // console.log(res);
        if (res.code == 200) {
          this.domainUrl = res.data.url;
          this.intelist();
        }
      });
    },
    //产品线列表
    produdata() {
      let data = {
        currency_id:parseInt(localStorage.getItem('countryId'))
      };
      getProducts(data).then(res => {
        // console.log(res);
        if (res.status_code == 200) {
          this.prodlist = res.data;
        }
      });
    },
    //设备积分列表
    intelist() {
      let data = {
        p_id: this.userform.Product,
        name: this.userform.name,
        page: this.currentindex,
        page_size: this.pageSize,
        currency_id:parseInt(localStorage.getItem('countryId'))
      };
      integrallists(data).then(res => {
        // console.log(res);
        if (res.status_code == 200) {
          res.data.data.forEach((ele, i) => {
            res.data.data[i].srcList = [];
            res.data.data[i].srcList.push(this.domainUrl + ele.img);
          });
          this.equipmentList = res.data.data;
          // console.log(this.domainUrl);
          // console.log(this.equipmentList);
          this.totals = res.data.total;
        }
      });
    },
    //分页切换
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentindex = val;
      this.intelist();
    },
    //搜索
    onSubmit() {
      // console.log(this.userform);
      this.currentindex = 1;
      this.intelist();
    },
    //取消搜索
    NOonsub() {
      this.userform.Product = "";
      this.userform.name = "";
      this.currentindex = 1;
      this.intelist();
    },
    // 新增--弹窗
    addPoints() {
      this.titleName = "新增";
      this.pop_up = true;
    },
    //图片上传
    handaddimg(file) {
      // console.log(file);
      let minfile = file.file;
      let form = new FormData();
      form.append("file", minfile);
      uploadimg(form).then(res => {
        // console.log(res);
        // console.log(this.addform.fileList);
        if (res.status_code == 200) {
          this.addform.fileList.push({
            name: res.data.original_name,
            url: res.data.url,
            path: res.data.path
          });
        }
      });
    },
    //删除图片
    handleRemove(file) {
      // console.log(file);
      // console.log(this.addform.fileList);
      this.addform.fileList.splice(0, 1);
      // console.log(this.addform.fileList);
    },
    //弹窗提交
    SubmitAdd() {
      // console.log(this.titleName);
      if (this.addform.fileList.length == 0) {
        this.$message({
          type: "warning",
          message: "请上传图片!"
        });
      } else if (this.addform.integral == "" || this.addform.integral < 0) {
        this.$message({
          type: "warning",
          message: "请输入正确积分!"
        });
      } else if (this.addform.p_id == "") {
        this.$message({
          type: "warning",
          message: "请选择产品线!"
        });
      } else if (this.addform.model == "") {
        this.$message({
          type: "warning",
          message: "请输入设备型号!"
        });
      } else if (this.addform.recommend_sort == "" && this.addform.is_top == 1) {
        this.$message({
          type: "warning",
          message: "请输入推荐排序!"
        });
      } else {
        this.addform.img = this.addform.fileList[0].path;
        // console.log(this.addform);
        if (this.titleName == "编辑") {
          let data = {
            id: this.addform.id,
            p_id: this.addform.p_id,
            img: this.addform.img,
            model: this.addform.model,
            recommend_sort: this.addform.recommend_sort,
            // serial_number: this.addform.serial_number,
            // name: this.addform.name,
            integral: this.addform.integral,
            currency_id:parseInt(localStorage.getItem('countryId'))
          };
          integraledit(data).then(res => {
            // console.log(res);
            if (res.status_code == 200) {
              this.currentindex = 1;
              this.intelist();
              this.pop_up = false;
              this.$message({
                type: "success",
                message: "修改成功!"
              });
            }
          });
        } else {
          let data = {
            p_id: this.addform.p_id,
            img: this.addform.img,
            model: this.addform.model,
            // serial_number: this.addform.serial_number,
            // name: this.addform.name,
            integral: this.addform.integral,
            currency_id:parseInt(localStorage.getItem('countryId'))
          };
          integraladd(data).then(res => {
            // console.log(res);
            if (res.status_code == 200) {
              this.pop_up = false;
              this.currentindex = 1;
              this.intelist();
              this.$message({
                type: "success",
                message: "添加成功!"
              });
            }
          });
        }
      }

      // this.pop_up = false;
    },
    //弹窗取消
    noform() {
      this.pop_up = false;
      this.recommend_up = false;
      this.recommendform.recommend = "";
      this.addform = {
        p_id: "",
        name: "",
        model: "",
        serial_number: "",
        integral: "",
        recommend_sort: "",
        is_top: "",
        fileList: []
      };
      this.rules.recommend_sort = "";
    },
    //推荐---取消推荐
    handleClick(e) {
      // console.log(e);
      this.recommenddata = e;
      if (e.is_top == 0) {
        this.recommend_up = true;
      }
      //取消已推荐
      if (e.is_top == 1) {
        let data = {
          id: e.id,
          is_top: 0,
          recommend_sort: 0,
          currency_id:localStorage.getItem('countryId')
        };
        integraleditTop(data).then(res => {
          if (res.status_code == 200) {
            this.currentindex = 1;
            this.intelist();
            this.$message({
              type: "success",
              message: "取消成功!"
            });
          } else {
            this.$message({
              type: "success",
              message: res.message
            });
          }
        });
      }
    },
    handleClickTwo() {
      // this.recommendform
      let data = {
        id: this.recommenddata.id,
        is_top: 1,
        recommend_sort: this.recommendform.recommend,
        currency_id:parseInt(localStorage.getItem('countryId'))
      };
      integraleditTop(data).then(res => {
        if (res.status_code == 200) {
          this.currentindex = 1;
          this.recommend_up = false;
          this.recommendform.recommend = "";
          this.intelist();
          this.$message({
            type: "success",
            message: "推荐成功!"
          });
        } 
      });
    },
    //编辑
    editbox(e) {
      this.titleName = "编辑";
      this.addform.id = e.id;
      this.addform.p_id = e.p_id;
      this.addform.name = e.name;
      this.addform.model = e.model;
      this.addform.serial_number = e.serial_number;
      this.addform.integral = e.integral;
      this.addform.fileList = [];
      if(e.img){
        this.addform.fileList.push({
          url: this.domainUrl + e.img,
          name: e.created_at,
          path: e.img
        });
      }
      
      this.addform.is_top = e.is_top;
      this.addform.recommend_sort = e.recommend_sort;
      if(e.is_top == 1) {
        this.rules.recommend_sort = [
          { required: true, message: "请输入推荐排序", trigger: "blur" }
        ];
      }
      this.pop_up = true;
    },
    //删除  integraldelete
    deletid(e) {
      // console.log(e);
      let data = {
        id: e.id
      };
      this.$confirm("此操作将删除该设备以及对应相关积分, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          integraldelete(data).then(res => {
            if (res.status_code == 200) {
              this.currentindex = 1;
              this.intelist();
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            }
          });
        })
        .catch(() => {});
    },
    //选中
    handleSelectionChange(val) {
      // console.log(val);
      this.Checklist = [];
      val.forEach(ele => {
        this.Checklist.push(ele.id);
      });
      // console.log(this.Checklist.toString());
    },
    //导出
    exportto() {
      let data = {
        ids: this.Checklist.toString(),
        type: "integral",
        where: {}
      };
      if (this.userform.Product == "" && this.userform.name == "") {
        data.where = "";
      } else if (this.userform.Product !== "") {
        data.where.p_id = this.userform.Product;
      } else if (this.userform.name !== "") {
        data.where.name = this.userform.name;
      }
      excelexport(data).then(res => {
        // console.log(res);
        const blob = new Blob([res]);
        const downloadElement = document.createElement("a");
        const href = window.URL.createObjectURL(blob); // 创建下载的链接
        downloadElement.href = href;
        downloadElement.download = "积分.xlsx"; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        document.body.removeChild(downloadElement); // 下载完成移除元素
        window.URL.revokeObjectURL(href); // 释放掉blob对象
      });
    },
    //导入--上传
    handlePreview(file) {
      // console.log(file);
      let minfile = file.file;
      let form = new FormData();
      form.append("file", minfile);
      form.append("type", "integral");
      form.append("currency_id",localStorage.getItem('countryId'))
      let data = {
        file: minfile,
        type: "integral"
      };
      excelimport(form).then(res => {
        if (res.status_code == 200) {
          this.currentindex = 1;
          this.giftListd();
          this.$message({
            type: "success",
            message: "导入成功!"
          });
        }
      });
    },
    //模板下载
    mode() {
      location.href= process.env.VUE_APP_BASE_API + '/template_file/jifen_template.xls'
      // integraltemplate().then(res => {
      //   // console.log(res);
      //   const blob = new Blob([res]);
      //   const downloadElement = document.createElement("a");
      //   const href = window.URL.createObjectURL(blob); // 创建下载的链接
      //   downloadElement.href = href;
      //   downloadElement.download = "积分模板.xlsx"; // 下载后文件名
      //   document.body.appendChild(downloadElement);
      //   downloadElement.click(); // 点击下载
      //   document.body.removeChild(downloadElement); // 下载完成移除元素
      //   window.URL.revokeObjectURL(href); // 释放掉blob对象
      // });
    },
    rowClassName({ row, rowIndex }) {
      //把每一行的索引放进row
      row.index = rowIndex;
    },
    //修改排序
    sort(e, i) {
      // console.log(e.index);
      // console.log(i);
      let data;
      if (i == 1) {
        //  减 上移
        data = {
          id1: e.id,
          id2: this.equipmentList[e.index - 1].id
        };
      } else {
        // 加 下移
        data = {
          id1: e.id,
          id2: this.equipmentList[e.index + 1].id
        };
      }
      // console.log(data);
      integraleditSort(data).then(res => {
        if (res.status_code == 200) {
          this.currentindex = 1;
          this.intelist();
          this.$message({
            message: "修改成功",
            type: "success"
          });
        }
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.domainName();
    this.produdata();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.management {
  padding: 20px 30px 0;
  .form_header {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .btn_box {
      margin-left: 20px;
    }
    .form_ri {
      display: flex;
      .upload-demo {
        margin: 0 10px;
      }
    }
  }
  .form_list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .user_list {
    padding: 20px 0;
  }
}
</style>
<style lang='scss'>
.management {
  .form_header {
    .el-form-item {
      margin-bottom: 0;
      margin-right: 20px;
    }
  }

  .el-table {
    border-top: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
  }
}
.hideUpload {
  .el-upload.el-upload--picture-card {
    display: none !important;
  }
}
</style>